import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, mergeProps as _mergeProps, createVNode as _createVNode, withModifiers as _withModifiers, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-794fbef6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex items-center gap-3 px-2" }
const _hoisted_2 = { class: "flex h-[42px] w-[42px] flex-shrink-0 items-center justify-center rounded-full bg-primary5" }
const _hoisted_3 = {
  xmlns: "http://www.w3.org/2000/svg",
  class: "h-[22px] w-[22px] text-primary30",
  viewBox: "0 0 24 24",
  "aria-hidden": "true"
}
const _hoisted_4 = ["d"]
const _hoisted_5 = { class: "flex flex-col" }
const _hoisted_6 = { class: "text-lg font-semibold text-textPrimary" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-[13px] text-gray-500" }, "Permissões efetivas por empresa, unidade e escala", -1))
const _hoisted_8 = { class: "flex h-[min(620px,70vh)] flex-col" }
const _hoisted_9 = { class: "flex flex-wrap gap-2.5 px-6 pb-3.5 pt-4" }
const _hoisted_10 = { class: "min-w-[300px] flex-[1.4]" }
const _hoisted_11 = ["title"]
const _hoisted_12 = {
  key: 1,
  "data-testid": "permissions-tree-company-overflow",
  class: "whitespace-nowrap text-xs font-medium text-gray-500"
}
const _hoisted_13 = { class: "relative h-10 min-w-[180px] flex-1" }
const _hoisted_14 = {
  xmlns: "http://www.w3.org/2000/svg",
  class: "pointer-events-none absolute left-3 top-1/2 h-[18px] w-[18px] -translate-y-1/2 text-gray-400",
  viewBox: "0 0 24 24",
  "aria-hidden": "true"
}
const _hoisted_15 = ["d"]
const _hoisted_16 = ["value"]
const _hoisted_17 = {
  key: 0,
  class: "flex flex-wrap items-center justify-between gap-2 border-y border-gray-100 bg-gray-50 px-6 py-2.5"
}
const _hoisted_18 = {
  xmlns: "http://www.w3.org/2000/svg",
  class: "h-[18px] w-[18px]",
  viewBox: "0 0 24 24",
  "aria-hidden": "true"
}
const _hoisted_19 = ["d"]
const _hoisted_20 = { class: "custom-scrollbar min-h-0 flex-1 overflow-y-auto px-4 py-2" }
const _hoisted_21 = {
  key: 4,
  "data-testid": "permissions-tree-no-results",
  class: "flex h-full flex-col items-center justify-center gap-2 py-10 text-center"
}
const _hoisted_22 = {
  xmlns: "http://www.w3.org/2000/svg",
  class: "h-8 w-8 text-gray-400",
  viewBox: "0 0 24 24",
  "aria-hidden": "true"
}
const _hoisted_23 = ["d"]
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-sm text-gray-500" }, "Nenhum resultado para os filtros atuais", -1))
const _hoisted_25 = {
  key: 5,
  role: "tree",
  class: "flex flex-col pb-6"
}
const _hoisted_26 = {
  key: 0,
  "data-testid": "permissions-tree-filter-partial-warning",
  class: "px-2 py-1 text-xs text-gray-500"
}
const _hoisted_27 = {
  key: 2,
  class: "flex w-full items-center justify-center py-4 text-center"
}
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "rounded-full border border-gray-100 bg-gray-50 px-3 py-1 text-xs font-medium text-gray-500" }, " Todos os registros carregados. ", -1))
const _hoisted_29 = [
  _hoisted_28
]
const _hoisted_30 = {
  key: 3,
  class: "pointer-events-none h-8 w-full opacity-0"
}
const _hoisted_31 = { class: "flex w-full flex-wrap items-center justify-between gap-3" }
const _hoisted_32 = {
  "data-testid": "permissions-tree-legend",
  class: "flex flex-wrap items-center gap-4"
}
const _hoisted_33 = { class: "flex items-center gap-1 text-xs text-gray-500" }
const _hoisted_34 = {
  xmlns: "http://www.w3.org/2000/svg",
  class: "h-3.5 w-3.5 text-primary30",
  viewBox: "0 0 24 24",
  "aria-hidden": "true"
}
const _hoisted_35 = ["d"]
const _hoisted_36 = { class: "flex items-center gap-1 text-xs text-gray-500" }
const _hoisted_37 = {
  xmlns: "http://www.w3.org/2000/svg",
  class: "h-3.5 w-3.5 text-purple-700",
  viewBox: "0 0 24 24",
  "aria-hidden": "true"
}
const _hoisted_38 = ["d"]

import { computed, onBeforeUnmount, ref, watch } from 'vue'
import {
  mdiAccount,
  mdiAccountGroup,
  mdiCursorDefaultClickOutline,
  mdiDomain,
  mdiMagnify,
  mdiMagnifyRemoveOutline,
  mdiShieldAccount,
  mdiUnfoldLessHorizontal,
  mdiUnfoldMoreHorizontal
} from '@mdi/js'

import Network from '@/Network'
import type {
  AccessibleCompanyOption,
  PermissionTreeItem
} from '@/Network/Types/Responses/PermissionResponses'
import FilledButton from '@/components/designSystem/Buttons/FilledButton/index.vue'
import EmptyState from '@/components/designSystem/EmptyState/EmptyState.vue'
import ReportErrorState from '@/components/designSystem/ErrorState/ReportErrorState.vue'
import SegmentedControl from '@/components/designSystem/Inputs/SegmentedControl.vue'
import PermissionsTreeSkeleton from '@/components/designSystem/Skeleton/PermissionsTreeSkeleton.vue'
import ModalVue from '@/components/designSystem/modals/Modal.vue'
import { useInfiniteScroll } from '@/composables/useInfiniteScroll'
import {
  EModals,
  useModalStore,
  type ModalMetadata,
  type permissionsTreeModalDataType
} from '@/pinia-store/useModalStore'
import { AuthorizationResourcesAndSubjects } from '@/types/authorization'
import { getApiErrorMessage } from '@/utils/apiError'

import PermissionTreeRow from './components/PermissionTreeRow.vue'
import { countPermissionsByOrigin, flattenPermissionsTree } from './flattenTree'
import type { PermissionsTreeFilterState } from './types'
import { collectExpandableKeys, getNodeKey } from './utils'

const ITEMS_PER_PAGE = 20
const SEARCH_DEBOUNCE_MS = 150
/** Chips visíveis no select de empresas antes do contador "+N outras". */
const MAX_VISIBLE_COMPANY_CHIPS = 2


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const modalStore = useModalStore()

const modalActive = computed(() => modalStore.modals[EModals.PERMISSIONS_TREE])

const isPermissionsTreeMetadata = (
  metadata: ModalMetadata | undefined
): metadata is permissionsTreeModalDataType => {
  if (!metadata) return false
  const candidate = metadata as Partial<permissionsTreeModalDataType>
  return typeof candidate.subjectId === 'number' && typeof candidate.subjectType === 'string'
}

const subjectMetadata = computed<permissionsTreeModalDataType | null>(() =>
  isPermissionsTreeMetadata(modalStore.metadata) ? modalStore.metadata : null
)

const subjectId = computed(() => subjectMetadata.value?.subjectId ?? null)
const subjectType = computed(
  () => subjectMetadata.value?.subjectType ?? AuthorizationResourcesAndSubjects.User
)
const subjectName = computed(() => subjectMetadata.value?.subjectName)

const permissionsTree = ref<PermissionTreeItem[]>([])
const availableCompanies = ref<AccessibleCompanyOption[]>([])
// Todas as empresas acessíveis entram selecionadas ao abrir; o seletor serve
// para DES-selecionar (a árvore recarrega com as restantes).
const selectedCompanyIds = ref<number[]>([])
const expandedKeys = ref<Record<string, boolean>>({})

const loadingTree = ref(false)
const loadingCompanies = ref(false)
const loadError = ref<string | null>(null)
const errorSource = ref<'companies' | 'tree'>('tree')
const hasMore = ref(true)

const isUserSubject = computed(() => subjectType.value === AuthorizationResourcesAndSubjects.User)

const modalTitle = computed(() => {
  if (subjectName.value) return `Permissões de ${subjectName.value}`
  return isUserSubject.value ? 'Permissões do Usuário' : 'Permissões do Grupo'
})

// ── Busca e filtros (client-side, sobre os itens já carregados) ─────────────
// A sentinela do infinite scroll continua renderizada com filtro ativo: páginas
// novas entram em `permissionsTree` e são re-achatadas pelo computed. Se a
// visão filtrada ficar vazia, o estado "sem resultados" substitui a lista (e a
// sentinela), pausando o scroll até os filtros mudarem.
const createDefaultFilters = (): PermissionsTreeFilterState => ({ search: '', origin: 'all' })

const filters = ref<PermissionsTreeFilterState>(createDefaultFilters())

const searchText = ref('')
let searchDebounceTimer: ReturnType<typeof setTimeout> | undefined

onBeforeUnmount(() => clearTimeout(searchDebounceTimer))

const onSearchInput = (event: Event): void => {
  searchText.value = (event.target as HTMLInputElement).value
  clearTimeout(searchDebounceTimer)
  searchDebounceTimer = setTimeout(() => {
    filters.value = { ...filters.value, search: searchText.value }
  }, SEARCH_DEBOUNCE_MS)
}

const resetFilters = (): void => {
  clearTimeout(searchDebounceTimer)
  searchText.value = ''
  filters.value = createDefaultFilters()
}

const filtersActive = computed(
  () => filters.value.search.trim().length > 0 || filters.value.origin !== 'all'
)

const rows = computed(() =>
  flattenPermissionsTree(permissionsTree.value, {
    query: filters.value.search,
    origin: filters.value.origin,
    expandedKeys: expandedKeys.value
  })
)

const originCounts = computed(() => countPermissionsByOrigin(permissionsTree.value))

const originOptions = computed(() => [
  { label: 'Todas', value: 'all' as const, count: originCounts.value.all },
  { label: 'Diretas', value: 'direct' as const, count: originCounts.value.direct },
  { label: 'Via grupo', value: 'group' as const, count: originCounts.value.group }
])
// ── fim do bloco de busca e filtros ─────────────────────────────────────────

async function fetchPermissionsTree(isLoadMore = false): Promise<void> {
  if (!subjectId.value || selectedCompanyIds.value.length === 0) {
    permissionsTree.value = []
    loadingTree.value = false
    return
  }

  if (!isLoadMore) loadingTree.value = true
  loadError.value = null

  try {
    const offset = isLoadMore ? permissionsTree.value.length : 0
    const newData = await Network.permission.getSubjectPermissionsTree(
      subjectId.value,
      subjectType.value,
      [...selectedCompanyIds.value],
      offset,
      ITEMS_PER_PAGE
    )

    if (isLoadMore) {
      // Cinto de segurança contra regressão de paginação do backend: se a página
      // não trouxe NENHUM nó novo (por getNodeKey), para o infinite scroll em vez
      // de apendar duplicatas infinitamente.
      const loadedKeys = new Set(permissionsTree.value.map((node) => getNodeKey(node)))
      const freshNodes = newData.filter((node) => !loadedKeys.has(getNodeKey(node)))
      if (freshNodes.length === 0) {
        hasMore.value = false
        return
      }
      permissionsTree.value.push(...freshNodes)
    } else {
      permissionsTree.value = newData
    }

    hasMore.value = newData.length >= ITEMS_PER_PAGE
  } catch (error) {
    errorSource.value = 'tree'
    loadError.value = getApiErrorMessage(error, 'Não foi possível carregar a árvore de permissões.')
    hasMore.value = false
  } finally {
    loadingTree.value = false
  }
}

async function fetchAvailableCompanies(): Promise<void> {
  if (!subjectId.value) return
  loadingCompanies.value = true
  try {
    availableCompanies.value = await Network.permission.getSubjectAccessibleCompanies(
      subjectId.value,
      subjectType.value
    )
    // Abertura já carrega a árvore de TODAS as empresas acessíveis (accordion
    // fechado); o watcher de selectedCompanyIds dispara o fetch.
    selectedCompanyIds.value = availableCompanies.value.map((company) => company.id)
  } catch (error) {
    errorSource.value = 'companies'
    loadError.value = getApiErrorMessage(error, 'Não foi possível carregar a lista de empresas.')
  } finally {
    loadingCompanies.value = false
  }
}

const {
  isLoadingMore,
  onIntersect,
  reset: resetInfiniteScroll
} = useInfiniteScroll({
  loadMore: () => fetchPermissionsTree(true),
  hasMore: () => hasMore.value,
  isBusy: () => loadingTree.value
})

const resetState = (): void => {
  selectedCompanyIds.value = []
  permissionsTree.value = []
  availableCompanies.value = []
  expandedKeys.value = {}
  resetFilters()
  loadError.value = null
  errorSource.value = 'tree'
  hasMore.value = true
  loadingTree.value = false
  loadingCompanies.value = false
  resetInfiniteScroll()
}

watch(modalActive, (isOpen) => {
  if (!isOpen) return
  resetState()
  if (subjectId.value) fetchAvailableCompanies()
})

watch(selectedCompanyIds, () => {
  permissionsTree.value = []
  // Accordion fechado por padrão: a árvore carrega toda recolhida.
  expandedKeys.value = {}
  resetFilters()
  hasMore.value = true
  loadError.value = null
  resetInfiniteScroll()
  if (selectedCompanyIds.value.length > 0) fetchPermissionsTree(false)
})

const removeCompany = (companyId: number): void => {
  selectedCompanyIds.value = selectedCompanyIds.value.filter((id) => id !== companyId)
}

const retryAfterError = (): void => {
  loadError.value = null
  if (errorSource.value === 'companies') {
    fetchAvailableCompanies()
    return
  }
  fetchPermissionsTree(false)
}

const anyExpanded = computed(() => Object.keys(expandedKeys.value).length > 0)

const toggleExpandAll = (): void => {
  if (anyExpanded.value) {
    expandedKeys.value = {}
    return
  }
  expandedKeys.value = Object.fromEntries(
    collectExpandableKeys(permissionsTree.value).map((key) => [key, true])
  )
}

const toggleNode = (key: string): void => {
  // Com filtro ativo o toggle manual é no-op: a expansão exibida é forçada pelo
  // flatten (forceOpen) e o estado do usuário fica preservado para quando os
  // filtros forem limpos.
  if (filtersActive.value) return
  const next = { ...expandedKeys.value }
  if (next[key]) delete next[key]
  else next[key] = true
  expandedKeys.value = next
}

const close = (): void => {
  modalStore.toggleModal(EModals.PERMISSIONS_TREE)
}

return (_ctx: any,_cache: any) => {
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_autocomplete = _resolveComponent("v-autocomplete")!
  const _directive_intersect = _resolveDirective("intersect")!

  return (_openBlock(), _createBlock(ModalVue, {
    modalActive: modalActive.value,
    maxWidth: "max-w-5xl",
    maxHeight: "90vh",
    hasFooterBorder: true,
    noBodyPadding: "",
    onClose: close
  }, {
    header: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          (_openBlock(), _createElementBlock("svg", _hoisted_3, [
            _createElementVNode("path", {
              d: _unref(mdiShieldAccount),
              fill: "currentColor"
            }, null, 8, _hoisted_4)
          ]))
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("span", _hoisted_6, _toDisplayString(modalTitle.value), 1),
          _hoisted_7
        ])
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _createVNode(_component_v_autocomplete, {
              modelValue: selectedCompanyIds.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedCompanyIds).value = $event)),
              "data-testid": "permissions-tree-company-autocomplete",
              items: availableCompanies.value,
              "item-title": "name",
              "item-value": "id",
              label: "Empresas ativas",
              placeholder: "Todas as empresas carregadas",
              color: "primary20",
              variant: "outlined",
              density: "compact",
              "hide-details": "",
              multiple: "",
              clearable: "",
              loading: loadingCompanies.value,
              "prepend-inner-icon": _unref(mdiDomain),
              "no-data-text": "Nenhuma empresa acessível encontrada.",
              class: "bg-white"
            }, {
              item: _withCtx(({ props: itemProps, item }) => [
                _createVNode(_component_v_list_item, _mergeProps(itemProps, {
                  title: item.raw.name,
                  subtitle: "Empresa"
                }), null, 16, ["title"])
              ]),
              selection: _withCtx(({ item, index }) => [
                (index < MAX_VISIBLE_COMPANY_CHIPS)
                  ? (_openBlock(), _createBlock(_component_v_chip, {
                      key: 0,
                      size: "small",
                      closable: "",
                      "onClick:close": _withModifiers(($event: any) => (removeCompany(item.raw.id)), ["stop"])
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("span", {
                          class: "max-w-[120px] truncate",
                          title: item.raw.name
                        }, _toDisplayString(item.raw.name), 9, _hoisted_11)
                      ]),
                      _: 2
                    }, 1032, ["onClick:close"]))
                  : (index === MAX_VISIBLE_COMPANY_CHIPS)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_12, " +" + _toDisplayString(selectedCompanyIds.value.length - MAX_VISIBLE_COMPANY_CHIPS) + " " + _toDisplayString(selectedCompanyIds.value.length - MAX_VISIBLE_COMPANY_CHIPS === 1 ? 'outra' : 'outras'), 1))
                    : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["modelValue", "items", "loading", "prepend-inner-icon"])
          ]),
          _createElementVNode("div", _hoisted_13, [
            (_openBlock(), _createElementBlock("svg", _hoisted_14, [
              _createElementVNode("path", {
                d: _unref(mdiMagnify),
                fill: "currentColor"
              }, null, 8, _hoisted_15)
            ])),
            _createElementVNode("input", {
              "data-testid": "permissions-tree-search-input",
              value: searchText.value,
              type: "text",
              placeholder: "Buscar unidade, escala ou ID",
              class: "h-10 w-full rounded-lg border border-gray-300 pl-10 pr-3 text-sm text-textPrimary outline-none placeholder:text-gray-400 focus:border-primary20 focus:ring-2 focus:ring-primary5",
              onInput: onSearchInput
            }, null, 40, _hoisted_16)
          ])
        ]),
        (selectedCompanyIds.value.length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
              _createVNode(SegmentedControl, {
                modelValue: filters.value.origin,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((filters.value.origin) = $event)),
                options: originOptions.value,
                testIdPrefix: "permissions-tree-origin"
              }, null, 8, ["modelValue", "options"]),
              (permissionsTree.value.length > 0)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    "data-testid": "permissions-tree-expand-toggle-button",
                    type: "button",
                    class: "flex h-[30px] items-center gap-1.5 rounded-md px-2.5 text-sm font-medium text-primary30 transition-colors hover:bg-primary5",
                    onClick: toggleExpandAll
                  }, [
                    (_openBlock(), _createElementBlock("svg", _hoisted_18, [
                      _createElementVNode("path", {
                        d: anyExpanded.value ? _unref(mdiUnfoldLessHorizontal) : _unref(mdiUnfoldMoreHorizontal),
                        fill: "currentColor"
                      }, null, 8, _hoisted_19)
                    ])),
                    _createTextVNode(" " + _toDisplayString(anyExpanded.value ? 'Recolher tudo' : 'Expandir tudo'), 1)
                  ]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_20, [
          ((loadingTree.value || loadingCompanies.value) && permissionsTree.value.length === 0)
            ? (_openBlock(), _createBlock(PermissionsTreeSkeleton, { key: 0 }))
            : (loadError.value)
              ? (_openBlock(), _createBlock(ReportErrorState, {
                  key: 1,
                  title: "Não foi possível carregar",
                  message: loadError.value,
                  onRetry: retryAfterError
                }, null, 8, ["message"]))
              : (selectedCompanyIds.value.length === 0)
                ? (_openBlock(), _createBlock(EmptyState, {
                    key: 2,
                    variant: "dashed",
                    icon: _unref(mdiCursorDefaultClickOutline),
                    title: "Nenhuma empresa selecionada",
                    description: "Use o seletor acima para escolher as empresas exibidas na árvore."
                  }, null, 8, ["icon"]))
                : (permissionsTree.value.length === 0)
                  ? (_openBlock(), _createBlock(EmptyState, {
                      key: 3,
                      title: "Nenhuma permissão encontrada",
                      description: "Não há permissões para esta seleção."
                    }))
                  : (filtersActive.value && rows.value.length === 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                        (_openBlock(), _createElementBlock("svg", _hoisted_22, [
                          _createElementVNode("path", {
                            d: _unref(mdiMagnifyRemoveOutline),
                            fill: "currentColor"
                          }, null, 8, _hoisted_23)
                        ])),
                        _hoisted_24
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_25, [
                        (filtersActive.value && hasMore.value)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_26, " A busca considera apenas os itens já carregados. "))
                          : _createCommentVNode("", true),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(rows.value, (row) => {
                          return (_openBlock(), _createBlock(PermissionTreeRow, {
                            key: row.key,
                            row: row,
                            onToggle: toggleNode
                          }, null, 8, ["row"]))
                        }), 128)),
                        (_unref(isLoadingMore))
                          ? (_openBlock(), _createBlock(PermissionsTreeSkeleton, {
                              key: 1,
                              rows: 3,
                              class: "py-2"
                            }))
                          : _createCommentVNode("", true),
                        (!hasMore.value && !_unref(isLoadingMore))
                          ? (_openBlock(), _createElementBlock("div", _hoisted_27, _hoisted_29))
                          : _createCommentVNode("", true),
                        (hasMore.value && !_unref(isLoadingMore))
                          ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_30, null, 512)), [
                              [_directive_intersect, _unref(onIntersect)]
                            ])
                          : _createCommentVNode("", true)
                      ]))
        ])
      ])
    ]),
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_31, [
        _createElementVNode("div", _hoisted_32, [
          _createElementVNode("span", _hoisted_33, [
            (_openBlock(), _createElementBlock("svg", _hoisted_34, [
              _createElementVNode("path", {
                d: _unref(mdiAccount),
                fill: "currentColor"
              }, null, 8, _hoisted_35)
            ])),
            _createTextVNode(" Direta: atribuída ao usuário ")
          ]),
          _createElementVNode("span", _hoisted_36, [
            (_openBlock(), _createElementBlock("svg", _hoisted_37, [
              _createElementVNode("path", {
                d: _unref(mdiAccountGroup),
                fill: "currentColor"
              }, null, 8, _hoisted_38)
            ])),
            _createTextVNode(" Grupo: herdada de um grupo ")
          ])
        ]),
        _createVNode(FilledButton, {
          "data-testid": "permissions-tree-close-button",
          text: "Fechar",
          width: "120px",
          height: "40px",
          onClick: close
        })
      ])
    ]),
    _: 1
  }, 8, ["modalActive"]))
}
}

})